import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const XCircleIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6517 6.40901C10.9445 6.11612 10.9445 5.64124 10.6517 5.34835C10.3588 5.05546 9.88388 5.05546 9.59099 5.34835L10.6517 6.40901ZM5.34835 9.59099C5.05546 9.88388 5.05546 10.3588 5.34835 10.6517C5.64124 10.9445 6.11612 10.9445 6.40901 10.6517L5.34835 9.59099ZM9.59099 10.6517C9.88388 10.9445 10.3588 10.9445 10.6517 10.6517C10.9445 10.3588 10.9445 9.88388 10.6517 9.59099L9.59099 10.6517ZM6.40901 5.34835C6.11612 5.05546 5.64124 5.05546 5.34835 5.34835C5.05546 5.64124 5.05546 6.11612 5.34835 6.40901L6.40901 5.34835ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25V14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25ZM8 13.25C5.1005 13.25 2.75 10.8995 2.75 8H1.25C1.25 11.7279 4.27208 14.75 8 14.75V13.25ZM2.75 8C2.75 5.1005 5.1005 2.75 8 2.75V1.25C4.27208 1.25 1.25 4.27208 1.25 8H2.75ZM8 2.75C10.8995 2.75 13.25 5.1005 13.25 8H14.75C14.75 4.27208 11.7279 1.25 8 1.25V2.75ZM9.59099 5.34835L7.46967 7.46967L8.53033 8.53033L10.6517 6.40901L9.59099 5.34835ZM7.46967 7.46967L5.34835 9.59099L6.40901 10.6517L8.53033 8.53033L7.46967 7.46967ZM10.6517 9.59099L8.53033 7.46967L7.46967 8.53033L9.59099 10.6517L10.6517 9.59099ZM8.53033 7.46967L6.40901 5.34835L5.34835 6.40901L7.46967 8.53033L8.53033 7.46967Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

XCircleIcon.displayName = 'XCircleIcon';
